// 横向堆叠柱状图
import { Axis, Tooltip, Grid, Legend } from "dependencies/bigScreen/publicChartOptions/options"
export const chartOption8 = {
  styleId:8,
  pluginName: [],
  refreshTime: 90000, //间隔刷新时间
  // 是否显示柱图折线转化
  isBarToLine: false,
  tooltip: new Tooltip("axis", {
    textStyle: {
      color: "rgba(255, 255, 255, 0.8)",
      fontWeight: "400",
      fontSize: 14
    },
    backgroundColor: "rgba(0,0,0,1)",
    extraCssText: "border-radius: 10px;"
  }),
  // grid: new Grid(50, 50, 50, 50),
  legend: new Legend({
    top: "top",
    left: "left",
    show: false,
    data: ["数据1"],
    textStyle: { fontSize: 14, fontWeight: "400", color: "rgba(0, 0, 0, 0.8)" }
  }),
  radiusAxis: new Axis("category", {
    show: true,
    z: 2,
    data: [
      { value: "A地男", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" ,color: "rgba(0, 0, 0, 0.8)"} },
      { value: "A地女", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" ,color: "rgba(0, 0, 0, 0.8)"} },
      { value: "B地男", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" ,color: "rgba(0, 0, 0, 0.8)"} }
    ],
    axisLabel: {
      padding: [0, 0],
      show: true,
      borderRadius: 0,
      interval: 0,
      margin: 20,
      fontSize: 14,
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.8)",
      rotate: 0,
      backgroundColor: "rgba(255, 255, 0, 0)"
    },
    nameTextStyle: {
      padding: [0, 0, 0, 0],
      fontSize: 20,
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.8)",
      fontFamily: "sans-serif"
    }
  }),
  angleAxis: new Axis("value", {
    show: false,
    axisLabel: {
      padding: [0, 0],
      show: true,
      borderRadius: 0,
      interval: 0,
      margin: 20,
      fontSize: 14,
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.8)",
      rotate: 0,
      backgroundColor: "rgba(255, 255, 0, 0)"
    },
    nameTextStyle: {
      padding: [0, 0, 0, 0],
      fontSize: 20,
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.8)",
      fontFamily: "sans-serif"
    }
  }),
  polar: {
    radius: [30, '75%']
  },
  animationEasing: "bounceOut",
  animationDuration: 1000,
  animationEasingUpdate: "bounceOut",
  animationDurationUpdate: 1000,
  seriesTempAttributes: {
    // 用于存放数据中的通用配置项
    coordinateType: "polar" //极坐标系
  },
  series: [
    {
      label: {
        formatter: "{c}{valueUnit|}",
        position: "top",
        show: false,
        rich: {
          valueUnit: { fontSize: 14, fontWeight: "400", color: "rgba(0, 0, 0, 0.8)" }
        },
        fontSize: 14,
        fontWeight: "400",

        color: "rgba(0, 0, 0, 0.8)",
        rotate: 0
      },
      barGap: "16%",
      emphasis: { focus: "series" },
      coordinateSystem: "polar",
      showBackground: true,
      type: "bar",
      name: "数据1",
      backgroundStyle: { color: "#E4EBF8" },
      roundCap: true,
      barWidth: "44%",
      colorBy: "series",
      itemStyle: { borderRadius: [0, 0, 10, 10], color: "rgba(0, 228, 228, 1)" },
      data: [
        { value: "15", itemStyle: { color: "rgba(0, 137, 255, 0.92)" } },
        { value: "10", itemStyle: { color: "rgba(128, 44, 245, 0.88)" } },
        { value: "20", itemStyle: { color: "rgba(0, 71, 255, 0.89)" } }
      ],
      animationDelay: { _custom: { type: "function", display: "<span>ƒ</span> (t)" } }
    }
  ]
}
